import { render, staticRenderFns } from "./PatientControlAvatar.vue?vue&type=template&id=9bf8cb56&scoped=true&"
import script from "./PatientControlAvatar.vue?vue&type=script&lang=ts&"
export * from "./PatientControlAvatar.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bf8cb56",
  null
  
)

export default component.exports